export default __webpack_public_path__ + "f93044d4f217423d94c1b070f64bd3e5.png";